import {
    UserRole
} from "../roleConfig";
import { User } from "../types/user";

export const filterTableDataByRole = (
    data: any[],
    userRoles: UserRole[],
    user: User | null
): any[] => {
    let filterData: any[] = data;
      if (!user) {
        return filterData;
      }

    // ====================================
    // 2️⃣ COLLECT ALLOWED TEMPLATES
    // ====================================
    const allowedTemplates = new Set < string > ();
    for (const role of userRoles) {
        // ----- ACTUAL -----
        if (
            role === UserRole.TrialActualAdmin ||
            role === UserRole.SBUTrialActualAdmin ||
            role === UserRole.TrialActualPortalControlAdmin ||
            role === UserRole.ActualViewAdmin
        ) {
            allowedTemplates.add("Trial Balance Plus - Actual");
        }

        if (
            role === UserRole.BusinessActualAdmin ||
            role === UserRole.SBUBusinessActualAdmin ||
            role === UserRole.BusinessActualPortalControlAdmin ||
            role === UserRole.ActualViewAdmin
        ) {
            allowedTemplates.add("Business Data - Actual");
        }

        // ----- BUDGET -----
        if (
            role === UserRole.TrialBudgetAdmin ||
            role === UserRole.SBUTrialBudgetAdmin ||
            role === UserRole.TrialBudgetPortalControlAdmin ||
            role === UserRole.BudgetViewAdmin
        ) {
            allowedTemplates.add("Trial Balance Plus - Budget 12M");
        }

        if (
            role === UserRole.BusinessBudgetAdmin ||
            role === UserRole.SBUBusinessBudgetAdmin ||
            role === UserRole.BusinessBudgetPortalControlAdmin ||
            role === UserRole.BudgetViewAdmin
        ) {
            allowedTemplates.add("Business Data - Budget");
        }
    }
    if (allowedTemplates.size > 0){
        filterData = filterData.filter(item => allowedTemplates.has(item.template_name));
    }

    // ====================================
    // 3️⃣ SBU LOGIC (LOWEST PRIORITY)
    // ====================================
    // Execute ONLY if Admin is NOT present
    if (userRoles.includes(UserRole.SBU)) {
        // Parse user's upload access permissions
        const uploadAccesses = parseUploadAccesses(user.upload_accesses || '');
        console.log("User upload accesses:", uploadAccesses);
        console.log("User email:", user.email ? user.email.toLowerCase() : undefined);

        // Filter data for SBU users based on their access permissions
        filterData = filterData.filter(item => {
            // Normalize entity code by removing leading zeros and whitespace
            const normalizedItemCode = item.entity_code.toString().replace(/^0+/, '').trim();

            const accessEntry = uploadAccesses.find(access => {
                const normalizedAccessCode = access.code.toString().replace(/^0+/, '').trim();
                return normalizedItemCode === normalizedAccessCode;
            });

            if (!accessEntry) {
                return false;
            }

            // Check if user has access to this template
            const hasTemplateAccess = accessEntry.files.some(file => file === item.template_name);
            return hasTemplateAccess;
        });
    }


    // ====================================
    // 4️⃣ FILTER FROM ORIGINAL DATA
    // ====================================
    return filterData;
};

interface TemplateAccess {
  code: string;
  files: string[];
}

export const parseUploadAccesses = (uploadAccesses: string | string[]): TemplateAccess[] => {
    const accessString = Array.isArray(uploadAccesses) ? uploadAccesses.join(',') : uploadAccesses;

    if (!accessString) {
        console.log("No upload accesses provided");
        return [];
    }

    // Split by entity codes
    const entitySections = accessString.split('||');
    console.log("Entity sections:", entitySections);

    const parsed = entitySections.map(access => {
        const [codeSection, filesSection] = access.split('|files:');

        // Fix: Extract only the entity code without the role part
        let code = codeSection.replace('code:', '');

        // If code has format like "0050:Primary", extract only "0050"
        if (code.includes(':')) {
            code = code.split(':')[0];
        }

        // Clean and parse files
        const files = (filesSection || '')
            .replace('[', '')
            .replace(']', '')
            .split(';')
            .map(f => f.trim())
            .filter(file => file.length > 0);

        return {
            code,
            files
        };
    });

    console.log("Final parsed upload accesses:", parsed);
    return parsed;
};